// extracted by mini-css-extract-plugin
export default {"backgroundEditor":"#eee","neon-card-grid":"neon-card-grid","neon-resizable-card":"neon-resizable-card","quiz-editor":"quiz-editor"};